<template>
  <el-col
      v-if="isKeyword"
      v-show="item.display"
      :span="8">
    <div class="keyword">
      <p :class="headerClass">
        {{ item.title }}
        <span>
          <el-checkbox
              :value="item.isAndSearch"
              class="search-check-box"
              @change="(val) => item.isAndSearch = val">
            AND検索
          </el-checkbox>
        </span>
      </p>
      <el-input
          v-model="item.value"
          v-validate="validationRule"
          :data-vv-scope="validationScope"
          :data-vv-name="uid"
          :data-vv-as="item.title"
          :placeholder="item.placeholder"
          clearable />
      <div v-show="errorMsg"
          class="is-error-msg">
        {{ errorMsg }}
      </div>
    </div>
  </el-col>
  <!-- MultiSelector -->
  <el-col
      v-else-if="item.type === 'MultiSelector' || item.type === 'SingleSelector'"
      v-show="item.display"
      :span="8">
    <div>
      <p :class="headerClass">{{ item.title }}</p>
      <el-select
          v-model="model"
          v-validate="validationRule"
          :data-vv-name="uid"
          :data-vv-as="item.title"
          :data-vv-scope="validationScope"
          :multiple="item.type === 'MultiSelector'"
          placeholder="Select"
          clearable
          @clear="clear">
        <el-option
            v-for="option in item.options"
            :key="option.code"
            :label="option.name"
            :value="option.code" />
      </el-select>
      <div v-show="errorMsg"
          class="is-error-msg">
        {{ errorMsg }}
      </div>
    </div>
  </el-col>
  <!-- Input -->
  <el-col
      v-else-if="item.type === 'Input'"
      v-show="item.display"
      :span="8">
    <div>
      <p :class="headerClass">{{ item.title }}</p>
      <el-input
          v-model="model"
          v-validate="validationRule"
          :data-vv-scope="validationScope"
          :data-vv-name="uid"
          :data-vv-as="item.title"
          :placeholder="item.placeholder"
          clearable />
      <div v-show="errorMsg"
          class="is-error-msg">
        {{ errorMsg }}
      </div>
    </div>
  </el-col>
  <!-- DateTime -->
  <el-col
      v-else-if="item.type === 'DateTime'"
      v-show="item.display"
      :span="8"
      class="block">
    <p :class="headerClass">{{ item.title }}</p>
    <div>
      <BaseValidDatePicker
          v-validate="validationRule"
          :data-vv-name="uid"
          :data-vv-as="item.title"
          :data-vv-scope="validationScope"
          :error-msg="errorMsg"
          :date-value="model"
          :value="model"
          :default-time="['00:00:00', '23:59:59']"
          :name="item.title"
          type="datetimerange"
          align="right"
          @input="input" />
    </div>
  </el-col>
  <el-col
      v-else-if="item.type === 'Date'"
      v-show="item.display"
      :span="8"
      class="block">
    <p :class="headerClass">{{ item.title }}</p>
    <div>
      <BaseValidDatePicker
          v-validate="validationRule"
          :data-vv-name="uid"
          :data-vv-as="item.title"
          :data-vv-scope="validationScope"
          :error-msg="errorMsg"
          :date-value="model"
          :value="model"
          :name="item.title"
          :default-value="item.defaultValue"
          type="daterange"
          align="right"
          @input="input" />
    </div>
  </el-col>
  <el-col
      v-else-if="item.type === 'NumberRange'"
      v-show="item.display"
      :span="8"
      class="block">
    <p :class="headerClass">{{ item.title }}</p>
    <div>
      <BaseValidRangeNumber
          :data-vv-scope="validationScope"
          :data-vv-name="uid"
          :test-value="model"
          :name="item.title"
          :value="model"
          :from-prefix="item.fromPreFix"
          :from-suffix="item.fromSuffix"
          :to-prefix="item.toPrefix"
          :to-suffix="item.toSuffix"
          :precision="item.precision"
          :placeholder="item.placeholder"
          :max-value="item.max"
          :min-value="item.min"
          :max-length="item.maxLength"
          type="number"
          @input="input" />
    </div>
  </el-col>
  <!-- type一致なし -->
  <div v-else />
</template>

<style scoped>
.NumberRange {
  display: flex;
}
.NumberRange input {
  width:100%;
  text-align: right;
}
.NumberRange .toLabel {
  margin-left: 10px;
  margin-right: 10px;
}
.NumberRange .yen {
  margin-left: 5px;
}

p.required:after {
  content: " *";
  color: #ff5a5a;
  font-size: 85%;
}

.keyword p {
  display: flex;
}

.keyword span {
  margin-left: auto;
}

</style>
<script>

import BaseValidDatePicker from '@/components/atoms/BaseValidDatePicker'
import BaseValidRangeNumber from '@/components/atoms/BaseValidRangeNumber'

export default {
  name: 'BaseSearchCondition',
  components: {
    BaseValidDatePicker,
    BaseValidRangeNumber
  },
  inject: ['parentValidator'],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    },
    name: {
      type: String,
      required: true
    },
    // store パス
    storePath: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false
    },
    validationScope: {
      type: String,
      default: 'searchCondition'
    },
    isKeyword: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    uid () {
      return this._uid.toString()
    },
    validationRule () {
      let rule = ''
      if (this.item.required) {
        rule = 'required'
      }

      if (this.item.maxLength != null) {
        if (rule !== '') rule += '|'
        rule += `max:${this.item.maxLength}`
      }

      return rule
    },
    errorMsg () {
      return this.errors.first(this.uid, this.validationScope)
    },
    model: {
      get () {
        return this.item.value
      },
      set (value) {
        this.$store.commit({
          type: 'updateSearchConditionsValue',
          storePath: this.storePath,
          path: this.name,
          value: value
        })
      }
    },
    headerClass () {
      return 'selector-title' + (this.item.required ? ' required' : '')
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  methods: {
    input: function (value) {
      this.model = value
    },
    clear: function () {
      if (this.item.type === 'MultiSelector') {
        this.model = []
      } else {
        this.model = ''
      }
    }
  }
}
</script>
